import React from 'react';

const AddIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="2" y="7.33325" width="12" height="1.13333" fill="#3c9041" />
      <rect x="7.33301" y="14" width="12" height="1.13333" transform="rotate(-90 7.33301 14)" fill="#3c9041" />
    </svg>
  );
};

export default AddIcon;
